import React, { useState, useEffect, FC } from 'react';
import { msToTime } from '../../helpers/helpers';
import { ElapsedTime as Props } from './types';

const ElapsedTime: FC<Props> = ({ start, end, status })  => {
  const [elapsed, setElapsed] = useState(status === 'live'? new Date().getTime() - start : status==='post' ? end - start : '-');
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (status==='live') {
      setTimeout(()=>{
        setElapsed(new Date().getTime() - start);
      }, 1000);
    }else if(status==='post'){
      setElapsed(end - start);
    }else {
      setElapsed('-');
    }
  });
  return (<>
    {typeof elapsed !== 'string' ? msToTime(elapsed) : elapsed}
  </>);
};

export default ElapsedTime;
